import { render, staticRenderFns } from "./MeetingQuestionReviewDr.vue?vue&type=template&id=2f38f76b&scoped=true"
import script from "./MeetingQuestionReviewDr.vue?vue&type=script&lang=ts"
export * from "./MeetingQuestionReviewDr.vue?vue&type=script&lang=ts"
import style0 from "./MeetingQuestionReviewDr.vue?vue&type=style&index=0&id=2f38f76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38f76b",
  null
  
)

export default component.exports